import React from 'react';
import PropTypes from 'prop-types';
import AppConfig from "../../AppConfig";
import Sidebar2 from "../sidebar2/Sidebar2";
import Links from "../../utilities/linksConfig/Links";
import loga from '../../images/logotypywszystkie.png'
import ResizeSensor from 'resize-sensor'
import ApiversionService from "../../modules/ApiversionService";

export default class SidebarComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            czyStopkaPrzyklejona: false,
            apiversion: '-',
        };
    }

    componentDidMount() {
        var sensor = new ResizeSensor(document.getElementById('contentChildren'), function () {

            if (Boolean(document.getElementById('contentChildren'))) {
                if (document.getElementById('contentChildren').offsetHeight > 600) {
                    this.setState({czyStopkaPrzyklejona: false})
                } else this.setState({czyStopkaPrzyklejona: true})
            } else this.setState({czyStopkaPrzyklejona: true})

        }.bind(this))

        this.pobierzWersjeApi();
    }

    pobierzWersjeApi() {
        ApiversionService.getApiversion().then(function (response) {
            if (response) {
                this.setState({apiversion: response.data})
            }
        }.bind(this))
    }

    render() {
        return (
            <div>

                <div id={'PASidebar'}>
                    {/*
                    <Sidebar isSidebarCollapsed={true} links={this.props.links} currentLink={this.props.currentLink} history={this.props.history}/>
                    */}
                    <Sidebar2 links={Links.getModuleLinks} collapsedLinks={this.props.collapsedLinks} currentLink={this.props.currentLink}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}/>
                </div>
                <div id={'PAMainContent'}>
                    <div id="subheader_background"></div>
                    <div id='content-page' style={{paddingLeft: '200px'}}>
                        <div id={'contentChildren'} style={{paddingBottom: 50}}>
                            {this.props.children}
                        </div>
                        <div id={'FooterApplication'} className={(this.state.czyStopkaPrzyklejona) ? 'sticky' : ''}>
                            <div id={'footer-container'}>
                                <div id={'dofinansowanie'}>
                                    <img src={loga}/>
                                    <p>
                                        Projekt współfinansowany z Europejskiego Funduszu Rozwoju Regionalnego w ramach poddziałania 1.4.1
                                        Regionalnego
                                        Programu Operacyjnego Województwa Podkarpackiego na lata 2014 – 2020.
                                    </p>
                                </div>
                                <div id={'nazwaiaktualizacja'}>
                                    <i className={'fa fa-bus'}></i> <span id={'nazwa'}>TOP eBUS</span> <span
                                    id={'aktualizacja'}>{AppConfig.APP_VER() + ' ' + AppConfig.APP_UPDATE()}
                                    , API: {this.state.apiversion}
                                </span>
                                    <div id={'realizacja'}>
                                        Realizacja: <a href="https://topsa.com.pl/">TOP S.A.</a> &copy; {new Date().toJSON().substr(0, 4)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

SidebarComponent.propTypes = {
    links: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/shared/sidebar/SidebarComponent.js